<div class="col-12 p-0 m-0" style="text-align: center;">

    <img style="width: 132px;margin: auto;" src="https://ik.imagekit.io/qdesq/qdesq/44517bd6895b9b13aad69673be8d937c_fvq7vIpklR.svg" alt="gdpr" />

    <p class="p-0 m-0 font16SemiBold blackHeading" style="margin-top: 15px !important;">We are now GDPR Compliant</p>

    <p class="p-0 m-0 font14Regular blackSubHeading" style="text-align: left;margin-top: 15px !important;">
        We have updated our  <a href="/terms-of-service" target="_blank" class="font14Regular blackSubHeading" style="text-decoration: underline;color:#1c1c1e">Terms of Service</a>, <a href="/privacy-policy" target="_blank" class="font14Regular blackSubHeading" style="text-decoration: underline;color:#1c1c1e">Privacy Policy</a>, <a href="/cookie-policy" target="_blank" class="font14Regular blackSubHeading" style="text-decoration: underline;color:#1c1c1e">Cookie Policy, and Data Processing Agreement (DPA)</a>. These updates reflect our commitment to transparency, evolving privacy regulations, and delivering a secure, compliant experience for all our users.

    </p>

    <p class="p-0 m-0 font14Regular blackSubHeading" style="text-align: left;margin-top: 26px !important;">
        Qudify is now fully compliant with GDPR and India’s Digital Personal Data Protection Act (DPDPA). We’ve also appointed a Data Protection Officer (DPO) and established local representation in both the EU and UK to better serve our global clientele.

    </p>

    <p class="p-0 m-0 font14Regular blackSubHeading" style="text-align: left;margin-top: 26px !important;margin-bottom: 16px !important;">
        <a href="/privacy-policy" target="_blank" class="font14Regular blackSubHeading" style="text-decoration: underline;color:#1c1c1e">To view our policies & terms in detail, click here.</a> You can also view them via hyperlinks below.

    </p>

     <app-accept-privacy-policy-and-terms style="margin-top: 15px !important;" [checkBoxSize]="'24px'"  [(privacyPolicyAcceptedDate)]="privacyPolicyAcceptedDate" ></app-accept-privacy-policy-and-terms>

     <div class="col-12 p-0 m-0" style="border-top: 1px solid #F3EFEF;">
         <button style="border: none;margin-top: 20px;width: 226px;margin: auto;margin-top: 10px !important;" [disabled]="!privacyPolicyAcceptedDate" (click)="submit()" [ngClass]="!privacyPolicyAcceptedDate ?'disabledUpdateBtn':'enabledUpdateBtn'" >
            Submit
        </button>
     </div>


</div>
<div *ngIf="customLoader" style="position: fixed;background-color:  rgba(0,0,0,.32);left: 0;top: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 50;">
    <span class="spinner"></span>
</div>